import React from 'react';
import { contractorTypes, honestLocal } from '../data/content';
import { CheckIcon } from './icons';
export function ContractorTypes() {
  return <section id="why" className="w-full bg-sand py-20 lg:py-28" data-id="element-37" data-mp="22coipo6vgars">
      <div className="mx-auto max-w-content px-5 lg:px-8" data-id="element-38" data-mp="1xfy4z7ijhr9j">
        <div className="max-w-3xl" data-id="element-39" data-mp="1sftmxd1zgoh7">
          <p className="text-sm font-semibold text-sky-600" data-id="element-40" data-mp="1sgl9jydlrbvc">Let&apos;s be direct</p>
          <h2 className="mt-3 font-display text-3xl font-extrabold leading-tight tracking-tight text-navy-800 sm:text-4xl" data-id="element-41" data-mp="2q43oxs1rrc8b">
            There are three types of pool contractors in Texas right now.
          </h2>
          <p className="mt-4 text-lg leading-relaxed text-navy-500" data-id="element-42" data-mp="2g4mj9amioycc">
            Most owners cycle through the first two, get frustrated, and put the repair off another
            year.
          </p>
        </div>

        <div className="mt-12 grid gap-6 lg:grid-cols-[minmax(0,1fr)_minmax(0,1fr)_minmax(0,1.25fr)]" data-id="element-43" data-mp="14r0l4zyojmeo">
          {contractorTypes.map(type => <article key={type.tag} className="flex h-full flex-col rounded-lg border border-navy-100 bg-white p-7" data-id="element-44" data-mp="10qqerm6z6tza">
              <type.icon className="h-8 w-8 text-navy-300" data-id="element-45" data-mp="27axz06qb1xkw" />
              <p className="mt-6 text-xs font-bold uppercase tracking-[0.16em] text-navy-300" data-id="element-46" data-mp="27afz904fp188">
                {type.tag}
              </p>
              <h3 className="mt-2 font-display text-xl font-bold text-navy-700" data-id="element-47" data-mp="1xci9g86xewdi">{type.title}</h3>
              <p className="mt-3 text-[15px] leading-relaxed text-navy-400" data-id="element-48" data-mp="1jldehjei6s9i">{type.body}</p>
              <p className="mt-auto pt-6 text-sm font-semibold text-navy-600" data-id="element-49" data-mp="1oc3m73aej77d">{type.verdict}</p>
            </article>)}

          <article className="flex h-full flex-col rounded-lg bg-navy-800 p-7 ring-1 ring-navy-700" data-id="element-50" data-mp="19nh4ww17s5di">
            <honestLocal.icon className="h-8 w-8 text-sky-300" data-id="element-51" data-mp="1elr3lgm5do3v" />
            <p className="mt-6 text-xs font-bold uppercase tracking-[0.16em] text-sky-300" data-id="element-52" data-mp="1ek7k7h572wxv">
              {honestLocal.tag} — that&apos;s us
            </p>
            <h3 className="mt-2 font-display text-xl font-bold text-white" data-id="element-53" data-mp="15kkl51zxu37z">{honestLocal.title}</h3>
            <ul className="mt-5 space-y-3" data-id="element-54" data-mp="37btdqxluk0mz">
              {honestLocal.points.map(point => <li key={point} className="flex gap-3 text-[15px] leading-relaxed text-navy-100" data-id="element-55" data-mp="32jjgsxmbe0b7">
                  <CheckIcon className="mt-1 h-4 w-4 shrink-0 text-sky-300" data-id="element-56" data-mp="2xkgp0evchql6" />
                  {point}
                </li>)}
            </ul>
            <p className="mt-auto pt-6 text-sm font-semibold text-sky-200" data-id="element-57" data-mp="2tky43j3ixfic">
              You&apos;re here because you&apos;re tired of the cycle.
            </p>
          </article>
        </div>
      </div>
    </section>;
}